
import * as fabric from 'fabric';
import Message from '@/utils/resetMessage';

export default class FabricCanvasHelper {
    constructor() {
        this.fabricCanvas = null;
        this.mousePosition = {
            x: 0,
            y: 0,
        }
        this.color = "#FC0000";
        this.lineWidth = 3;
    }
    initial(canvasDom, color, lineWidth) {
        this.fabricCanvas = canvasDom

        if (color) {
            this.color = color
        }

        if (lineWidth) {
            this.lineWidth = lineWidth
        }
    }
    getFabricCanvas() {
        return this.fabricCanvas
    }
    setDrawingMode(isDrawingMode) {
        this.fabricCanvas.isDrawingMode = isDrawingMode
    }
    getDrawingMode() {
        return this.fabricCanvas.isDrawingMode
    }
    startDrawing() {
        this.fabricCanvas.isDrawingMode = true
        this.fabricCanvas.freeDrawingBrush = new fabric.PencilBrush(this.fabricCanvas)
        this.fabricCanvas.freeDrawingBrush.color = this.color
        this.fabricCanvas.freeDrawingBrush.width = this.lineWidth
    }
    draw(fabricInstance) {
        this.fabricCanvas.add(fabricInstance)
        return fabricInstance
    }
    drawPolyline(points) {
        let polyline = new fabric.Polyline(points, {
            stroke: this.color,
            fill: 'rgba(255, 255, 255, 0)', // 透明填充
            strokeWidth: this.lineWidth,
            strokeLineCap: 'round', // 设置线段两端为圆角
            objectCaching: false, // 必须开启这玩意，否则无法绘制
            drawType: 'polyline'
        })
        this.draw(polyline)
        return polyline
    }
    drawArrow(from, to) {
        const x1 = from.x
        const y1 = from.y
        const x2 = to.x
        const y2 = to.y

        const w = x2 - x1
        const h = y2 - y1
        const sh = Math.cos(Math.PI / 4) * 16
        const sin = h / Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2))
        const cos = w / Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2))
        const w1 = (16 * sin) / 4
        const h1 = (16 * cos) / 4
        const centerX = sh * cos
        const centerY = sh * sin

        let path = ' M ' + x1 + ' ' + y1
        path += ' L ' + (x2 - centerX + w1) + ' ' + (y2 - centerY - h1)
        path += ' L ' + (x2 - centerX + w1 * 2) + ' ' + (y2 - centerY - h1 * 2)
        path += ' L ' + x2 + ' ' + y2
        path += ' L ' + (x2 - centerX - w1 * 2) + ' ' + (y2 - centerY + h1 * 2)
        path += ' L ' + (x2 - centerX - w1) + ' ' + (y2 - centerY + h1)
        path += ' Z'

        const object = new fabric.Path(path, {
            stroke: this.color,
            fill: this.color,
            strokeWidth: this.lineWidth,
            centeredRotation: true,
            drawType: 'arrow'
        })

        return this.draw(object);
    }
    drawCloudLine(from, to) {
        const x1 = from.x
        const y1 = from.y
        const x2 = to.x
        const y2 = to.y

        const n = 60

        const rx = Math.abs(x2 - x1)
        const ry = Math.abs(y2 - y1)

        const lRx = Math.floor(rx * 1.2)
        const lRy = Math.floor(ry * 1.2)

        const centerX = (x2 - x1) / 2 + x1
        const centerY = (y2 - y1) / 2 + y1

        let path = ''

        for (let angle = 0; angle <= 360; angle += 360 / n) {
            const t = Math.tan((angle / 360) * Math.PI)

            const px = (rx * (1 - t ** 2)) / (1 + t ** 2) + centerX
            const py = (ry * 2 * t) / (1 + t ** 2) + centerY

            if (angle === 0) {
                path += `M ${px} ${py}`
            } else if ((angle / (360 / n)) % 2 === 1) {
                const lpx = (lRx * (1 - t ** 2)) / (1 + t ** 2) + centerX
                const lpy = (lRy * 2 * t) / (1 + t ** 2) + centerY
                path += ` Q ${lpx} ${lpy}`
            } else {
                path += `,  ${px} ${py}`
            }
        }

        const object = new fabric.Path(path, {
            stroke: this.color,
            strokeWidth: this.lineWidth,
            fill: 'rgba(255, 255, 255, 0)',
            centeredRotation: true,
            drawType: 'cloudline'
        })

        return this.draw(object)
    }
    drawStar(from, to) {
        const x1 = from.x;
        const y1 = from.y;
        const x2 = to.x;
        const y2 = to.y;

        const width = Math.abs(x2 - x1);
        const height = Math.abs(y2 - y1);

        const centerX = (x2 + x1) / 2;
        const centerY = (y2 + y1) / 2;

        const outerRadius = Math.max(width, height) / 2; // 外圆半径
        const innerRadius = outerRadius / 2.5; // 内圆半径

        let path = '';
        const numPoints = 5; // 五角星的顶点数
        const angleStep = (Math.PI / numPoints); // 每个顶点的角度间隔

        for (let i = 0; i < numPoints * 2; i++) {
            const radius = i % 2 === 0 ? outerRadius : innerRadius; // 外顶点和内顶点交替
            const angle = i * angleStep - Math.PI / 2; // 起始角度偏移以使五角星正置

            const px = centerX + radius * Math.cos(angle);
            const py = centerY + radius * Math.sin(angle);

            if (i === 0) {
                path += `M ${px} ${py}`; // 移动到第一个点
            } else {
                path += ` L ${px} ${py}`; // 连接到下一个点
            }
        }

        path += ' Z'; // 闭合路径

        const object = new fabric.Path(path, {
            stroke: this.color,
            strokeWidth: this.lineWidth,
            fill: 'rgba(255, 255, 255, 0)',
            centeredRotation: true,
            drawType: 'star'
        });

        return this.draw(object);
    }
    drawRectangle(from, to) {
        const object = new fabric.Rect({
            top: Math.min(from.y, to.y), // 距离画布上边的距离
            left: Math.min(from.x, to.x), // 距离画布左侧的距离
            width: Math.abs(from.x - to.x), // 矩形的宽度
            height: Math.abs(from.y - to.y), // 矩形的高度
            fill: 'rgba(255, 255, 255, 0)',
            stroke: this.color,
            strokeWidth: this.lineWidth,
            drawType: 'rectangle'
        })

        return this.draw(object)
    }
    drawEllipse(from, to) {
        const x1 = from.x
        const y1 = from.y
        const x2 = to.x
        const y2 = to.y

        const object = new fabric.Ellipse({
            left: (x2 - x1) / 2 + x1,
            top: (y2 - y1) / 2 + y1,
            stroke: this.color,
            fill: 'rgba(255, 255, 255, 0)',
            originX: 'center',
            originY: 'center',
            rx: Math.abs(x1 - x2) / 2,
            ry: Math.abs(y1 - y2) / 2,
            strokeWidth: this.lineWidth,
            centeredRotation: true,
            drawType: 'ellipse'
        })

        return this.draw(object)
    }
    drawCross(from, to) {
        const x1 = from.x;
        const y1 = from.y;
        const x2 = to.x;
        const y2 = to.y;

        // 计算矩形框的宽度和高度
        const width = Math.abs(x2 - x1);
        const height = Math.abs(y2 - y1);

        // 矩形框的中心点
        const centerX = (x2 + x1) / 2;
        const centerY = (y2 + y1) / 2;

        // 定义叉号的路径
        let path = '';

        // 第一条对角线：左上到右下
        path += `M ${centerX - width / 2} ${centerY - height / 2}`; // 起点
        path += ` L ${centerX + width / 2} ${centerY + height / 2}`; // 终点

        // 第二条对角线：右上到左下
        path += ` M ${centerX + width / 2} ${centerY - height / 2}`; // 起点
        path += ` L ${centerX - width / 2} ${centerY + height / 2}`; // 终点

        // 创建 Path 对象
        const object = new fabric.Path(path, {
            stroke: this.color,
            strokeWidth: this.lineWidth,
            fill: 'rgba(255, 255, 255, 0)', // 无填充
            centeredRotation: true,
            drawType: 'cross'
        });

        return this.draw(object);
    }
    addTextBox(from) {
        // 创建文本框
        const textBox = new fabric.Textbox('', {
            left: from.x,
            top: from.y,
            fontSize: this.lineWidth,
            borderColor: this.color,
            fill: this.color,
            hasControls: false,
            centeredRotation: true,
            drawType: 'text'
        });

        // 添加到画布并进入编辑模式
        this.fabricCanvas.add(textBox);
        textBox.enterEditing();

        // 强制聚焦到隐藏的文本输入框
        setTimeout(() => {
            const hiddenTextarea = textBox.hiddenTextarea;
            if (hiddenTextarea) {
                hiddenTextarea.focus();
            }
        }, 0);

        // 监听文本改变事件
        textBox.on('changed', () => {
            let textCount = textBox.text.length;
            const maxLength = 200;
            if (textCount > maxLength) {
                Message.warning('文字个数已超过200个，超出部分将不再显示。');
                textBox.text = textBox.text.substring(0, maxLength);
                this.fabricCanvas.renderAll();
            }

        });

        return textBox;
    }
    updateTextBoxColor(object, color) {
        let text = object.text
        // 创建文本框
        const textBox = new fabric.Textbox(text, {
            left: object.left,
            top: object.top,
            fontSize: object.fontSize,
            borderColor: color,
            fill: color,
            hasControls: false,
            centeredRotation: true,
            drawType: 'text'
        });

        // 添加到画布并进入编辑模式
        this.fabricCanvas.remove(object);

        // 添加到画布并进入编辑模式
        this.fabricCanvas.add(textBox);
        textBox.enterEditing();

    }
    remove(fabricInstance) {
        return this.fabricCanvas.remove(fabricInstance)
    }
    clearActiveInstances() {
        this.fabricCanvas.getActiveObjects().forEach(item => {
            this.remove(item)
        })
    }
    clear() {
        this.fabricCanvas.clear()
    }
    rollback() {
        const objects = this.fabricCanvas.getObjects();
        this.remove(objects[objects.length - 1]);
    }
    getActiveObject() {
        return this.fabricCanvas.getActiveObject();
    }
    getActiveObjects() {
        return this.fabricCanvas.getActiveObjects();
    }
    getAllObjects() {
        return this.fabricCanvas.getObjects();
    }
    dispose() {
        this.fabricCanvas?.dispose()
    }
}